import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { delay, filter, take, takeUntil } from 'rxjs/operators';
import { GiantPerfectScrollbarDirective } from '../../../directives/giant-perfect-scrollbar/giant-perfect-scrollbar.directive';
import { GiantConfigService } from '../../../services/config-service';
import { GiantNavigationService } from '../../../navigation/navigation.service';
import { GiantSidebarService } from '../../../sidebar/sidebar.service';


@Component({
    selector     : 'navbar-vertical',
    templateUrl  : './vertical.component.html',
    styleUrls    : ['./vertical.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class NavbarVerticalStyle1Component implements OnInit, OnDestroy
{
    giantConfig: any;
    navigation: any;

    // Private
    private _giantPerfectScrollbar: GiantPerfectScrollbarDirective;
    private _unsubscribeAll: Subject<any>;

 
    constructor(
        private _giantConfigService: GiantConfigService,
        private _giantNavigationService: GiantNavigationService,
        private _giantSidebarService: GiantSidebarService,
        private _router: Router
    )
    {
        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    // Directive
    @ViewChild(GiantPerfectScrollbarDirective, {static: true})
    set directive(theDirective: GiantPerfectScrollbarDirective)
    {
        if ( !theDirective )
        {
            return;
        }

        this._giantPerfectScrollbar = theDirective;

        // Update the scrollbar on collapsable item toggle
        this._giantNavigationService.onItemCollapseToggled
            .pipe(
                delay(500),
                takeUntil(this._unsubscribeAll)
            )
            .subscribe(() => {
                this._giantPerfectScrollbar.update();
            });

        // Scroll to the active item position
        this._router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                take(1)
            )
            .subscribe(() => {
                    setTimeout(() => {
                        this._giantPerfectScrollbar.scrollToElement('navbar .nav-link.active', -120);
                    });
                }
            );
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        this._router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                takeUntil(this._unsubscribeAll)
            )
            .subscribe(() => {
                    if ( this._giantSidebarService.getSidebar('navbar') )
                    {
                        this._giantSidebarService.getSidebar('navbar').close();
                    }
                }
            );

        // Subscribe to the config changes
        this._giantConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((config) => {
                this.giantConfig = config;
            });

        // Get current navigation
        this._giantNavigationService.onNavigationChanged
            .pipe(
                filter(value => value !== null),
                takeUntil(this._unsubscribeAll)
            )
            .subscribe(() => {
                this.navigation = this._giantNavigationService.getCurrentNavigation();
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle sidebar opened status
     */
    toggleSidebarOpened(): void
    {
        this._giantSidebarService.getSidebar('navbar').toggleOpen();
    }

    /**
     * Toggle sidebar folded status
     */
    toggleSidebarFolded(): void
    {
        this._giantSidebarService.getSidebar('navbar').toggleFold();
    }
}
